import React, { useState } from "react";
import { Button, Card, Grid, Item, Popup } from "semantic-ui-react";
import history from "../../history";
import { actions, resources } from "../../shared/Literals";
import EsvdExportEsvd from "./EsvdExportEsvd";

import moment from "moment";
import { useReferenceInfo } from "../../providers/ReferenceInfoProvider";
import SummaryStatsButton from "../esvdStats/SummaryStatsButton";
import { useEsvdValuation } from "../../providers/EsvdValuationProvider";
import { ModalWithContextProvider, useModalWithContext } from "../../layouts/ModalWithContext";
import DataRequestForm from "./DataRequestForm";
import Can from "../../accessControls/Can";
import { useAuth } from "../../providers/AuthProvider";
import { defaultEsvdParams } from "../../models/EsvdQueryFilters";
import { User } from "../../models/user";
import UserProfileCompletionConsentForm from "./UserProfileCompletionConsentForm";

const EsvdActionsPanel = () => {
	const { currentInfo } = useReferenceInfo();
	const { esvdQueryParams, saveQueryParams } = useEsvdValuation();
	const { modalDispatcher } = useModalWithContext();
	const [fontsize, setFontsize] = useState(1.4);
	const { user } = useAuth();


	const isUserValid = (user?: User | null): boolean => {
		return Boolean(
			user &&
			user.displayName?.trim() &&
			user.email?.trim() &&
			user.organization?.trim() &&
			user.sector?.trim() &&
			user.purposeOfAccess?.trim()
		);
	};

	const toggleModal = () => {
		// verify user information is complete
		console.log(user)

		if (!isUserValid(user)) {
			modalDispatcher({
				open: true,
				size: "tiny",
				displayType: null,
				options: {
					title: "ESVD Full Database Access Request Form",
					body: <UserProfileCompletionConsentForm formDispatcher={modalDispatcher} />,
					closeOnDimmerClick: false,
				},
			});
			return
		}

		modalDispatcher({
			open: true,
			size: "tiny",
			displayType: null,
			options: {
				title: "ESVD Full Database Access Request Form",
				body: <DataRequestForm formDispatcher={modalDispatcher} />,
				closeOnDimmerClick: false,
			},
		});
	};
		
	return (
		<>
			<Card fluid>
				<Card.Content>
					<Item>
						<Item.Content>
							<Item.Header>
								<h4 className="title-card">Actions</h4>
							</Item.Header>
						</Item.Content>
					</Item>
				</Card.Content>
				<Card.Content>
					<ModalWithContextProvider>
						<SummaryStatsButton />
					</ModalWithContextProvider>
				</Card.Content>
				<Card.Content>
					<EsvdExportEsvd
						currentVersion={currentInfo || null}
						ButtonText="Download valuations as CSV"
						filename={`Esvd_Data_${moment().format(
							"Do-MMM-yyyy_HH-mm-ss"
						)}_Database_Version_${currentInfo?.version}.csv`}
						esvdQueryParams={esvdQueryParams}
						saveQueryParams={saveQueryParams}
					/>
					{/* <EsvdExportFilterEsvd /> */}
				</Card.Content>
				<Card.Content>
					<button
						className="btn btn-success btn-sm"
						onClick={() => history.push(resources.suggestStudy.path)}>
						Suggest a Study
					</button>
				</Card.Content>

			
				<Can
					action={actions.read}
					resource={resources.fullDataAccess.name}
					yes={() => 
					<Card.Content>
						<EsvdExportEsvd
							currentVersion={currentInfo || null}
							ButtonText="Download full ESVD as CSV"
							filename={`Esvd_Full_Data_${moment().format(
								"Do-MMM-yyyy_HH-mm-ss"
							)}_Database_Version_${currentInfo?.version}.csv`}
							esvdQueryParams={{ ...defaultEsvdParams }}
							isFull={true}										
						/>	
					</Card.Content>		
					}
					no={() => null}
				/>	
									
				<Card.Content style={{ minHeight: "6rem" }}>
					<Popup
						content="Click to request data."

						trigger={
				
					
								<Button
									positive
									content={"Get full ESVD as CSV"}
									onClick={toggleModal}
									// disabled={isLoading}
									// className={`${isLoading ? "invisible" : ""}`}
								/>	
						

					
											
						}
					/>					

				</Card.Content>


			</Card>
		</>
	);
};

export default EsvdActionsPanel;
